import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { locationCountryField } from './common/locationFields';
import { descriptionField } from './common/sharedFields';
import { currencyField } from './common/expenditureFields';

export const lobbyingMetadata = {
  displayName: msg({
    message: 'Lobbying',
    context: 'Activity data schema name for lobbying',
  }),
  fields: {
    ...coreFields,
    contribution_kind: {
      displayName: msg({
        message: 'Contribution kind',
        context: 'The display name for contribution kind field',
      }),
      externalDescription: msg({
        message:
          'The type of lobbying contribution, such as direct donation or PAC contribution.',
      }),
    },
    currency: currencyField,
    currency_quantity: {
      displayName: msg({
        message: 'Political contributions',
        context:
          'The display name for a metric describing the total amount of money spent (or estimated) on lobbying',
      }),
      externalDescription: msg({
        message:
          'The amount (or estimate) of money spent on lobbying and political contributions.',
        context: 'Currency quantity',
      }),
    },
    description: descriptionField,
    estimation_method: {
      displayName: msg({
        message: 'Estimation method',
        context: 'The display name for estimation method field',
      }),
    },
    expense_kind: {
      displayName: msg({
        message: 'Expense kind',
        context: 'The display name for expense kind field',
      }),
      externalDescription: msg({
        message: 'The category of lobbying expense.',
      }),
    },
    location_country: locationCountryField,
    recipient: {
      displayName: msg({
        message: 'Recipient',
        context: 'The display name for recipient field',
      }),
      externalDescription: msg({
        message:
          'The individual or organization that received lobbying expenditures or contributions.',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
